<!--Back Button-->
<div class="container d-none d-lg-block pt-3">
  <div class="rewards-back-button cursor-pointer" (click)="goBack()">
    <span class="material-icons align-middle fw-bold text-white">navigate_before</span>
  </div>
</div>

<!--Point Summary Bar-->
<fgb-points-summary-bar [backButtonLink]="'/rewards/raffles'" [backButtonTitle]="'Raffles'"></fgb-points-summary-bar>

<!--Lotto Details-->
<fgbcl-lotto-details [lottoId]="id" [showTermsAndConditions]="true"></fgbcl-lotto-details>
